import classnames from 'classnames';

export default function Pill({
  className,
  colour = 'pink',
  label,
  size = 'regular',
}) {
  const colourClass = (colourParam) => {
    switch (colourParam.toUpperCase()) {
      case 'BLACK':
        return 'bg-haiti text-white';
      case 'DARK_BLUE':
        return 'bg-zodiac text-white';
      case 'PINK':
        return 'bg-lavender-blush text-rose';
      default:
        return 'bg-rose text-white';
      case 'PURPLE':
        return 'bg-faded-cornflower text-cornflower';
    }
  };

  const sizeClass = (sizeParam) => {
    switch (sizeParam) {
      case 'small':
        return 'px-1 rounded-sm text-xxs';
      case 'large':
        return 'md:text-base px-2 py-1 rounded text-sm';
      case 'regular':
      default:
        return 'px-2 py-1 rounded text-xs';
    }
  };

  const labelClass = classnames(
    'font-medium mx-1 my-1',
    className,
    colourClass(colour),
    sizeClass(size),
  );

  return <span className={labelClass}>{label}</span>;
}
